export default
  {
    products: [
      {
        isoCountry: 'zw',
        portiFolio: "zesa",
        template: "airtime",
        icon: "",
        iconImg:"logo/zetdc.png",
        text: "Zesa Tokens",
        img: "",
        urlPath: "zesa",
        senderNumberRequired: true,
        isoSalesCurrency: "ZWD",
        isoCurrency: "R",
        displaySalesCurrency: true
      },
      {
        isoCountry: 'zw',
        portiFolio: "usdzesa",
        template: "airtime",
        icon: "",
        iconImg:"logo/zetdc.png",
        text: "USD Zesa Tokens",
        img: "",
        urlPath: "zesa",
        senderNumberRequired: true,
        isoSalesCurrency: "USD",
        isoCurrency: "R",
        displaySalesCurrency: true
      },
      {
        isoCountry: 'zw',
        portiFolio: "UsdEconet",
        icon: "",
        iconImg:"logo/econet.jpg",
        text: "Econet USD Airtime",
        template: "airtime",
        img: "",
        urlPath: "product",
        senderNumberRequired: true,
        isoSalesCurrency: "USD",
        isoCurrency: "R",
        displaySalesCurrency: true
      },
      {
        isoCountry: 'zw',
        portiFolio: "econetdata",
        icon: "",
        iconImg:"logo/econet.jpg",
        text: "Econet USD Data",
        template: "airtime",
        img: "",
        urlPath: "product",
        senderNumberRequired: true,
        isoSalesCurrency: "USD",
        isoCurrency: "R",
        displaySalesCurrency: true
      },
      {
        isoCountry: 'zw',
        portiFolio: "taura",
        icon: "",
        iconImg:"logo/taura.jpg",
        text: "Taura",
        template: "airtime",
        img: "",
        urlPath: "product",
        senderNumberRequired: true,
        isoSalesCurrency: "R",
        isoCurrency: "R",
        displaySalesCurrency: true
      },
      {
        isoCountry: 'zw',
        portiFolio: "usdnetoneairtime",
        icon: "",
        iconImg:"logo/netone.jpg",
        text: "NetOne USD Airtime",
        template: "airtime",
        img: "",
        urlPath: "product",
        senderNumberRequired: true,
        isoSalesCurrency: "USD",
        isoCurrency: "R",
        displaySalesCurrency: true
      },
      {
        isoCountry: 'zw',
        portiFolio: "usdtelecel",
        icon: "",
        iconImg:"logo/telecel.png",
        text: "Telecel USD Airtime",
        template: "airtime",
        img: "",
        urlPath: "product",
        senderNumberRequired: true,
        isoSalesCurrency: "USD",
        isoCurrency: "R",
        displaySalesCurrency: true
      },
      {
        isoCountry: 'za',
        portiFolio: "p-heita",
        template: "airtime",
        icon: "",
        iconImg:"logo/telkom.png",
        text: "Telkom",
        img: "",
        urlPath: "product",
        senderNumberRequired: false,
        isoSalesCurrency: "R",
        isoCurrency: "R",
        displaySalesCurrency: false
      },
      {
        isoCountry: 'za',
        portiFolio: "p-cellc",
        template: "airtime",
        backGroundColor: "dark",
        icon: "",
        iconImg:"logo/cellc.png",
        text: "Cell C",
        img: "",
        urlPath: "product",
        senderNumberRequired: false,
        isoSalesCurrency: "R",
        isoCurrency: "R",
        displaySalesCurrency: false
      },
      {
        isoCountry: 'za',
        portiFolio: "p-mtn",
        template: "airtime",
        backGroundColor: "warning",
        icon: "",
        iconImg:"logo/mtn.png",
        text: "MTN",
        img: "",
        urlPath: "product",
        senderNumberRequired: false,
        isoSalesCurrency: "R",
        isoCurrency: "R",
        displaySalesCurrency: false
      },
      {
        isoCountry: 'za',
        portiFolio: "p-vodacom",
        template: "airtime",
        backGroundColor: "danger",
        icon: "",
        iconImg:"logo/vodacom.png",
        text: "Vodacom",
        img: "",
        urlPath: "product",
        senderNumberRequired: false,
        isoSalesCurrency: "R",
        isoCurrency: "R",
        displaySalesCurrency: false
      },
      {
        isoCountry: 'mw',
        portiFolio: "tnmmalawi",
        icon: "",
        iconImg:"logo/tnm.png",
        text: "TNM",
        template: "airtime",
        img: "",
        urlPath: "product",
        senderNumberRequired: true,
        isoSalesCurrency: "MWK",
        isoCurrency: "R",
        displaySalesCurrency: true
      },
      {
        isoCountry: 'mw',
        portiFolio: "tnmdata",
        icon: "",
        iconImg:"logo/tnm.png",
        text: "TNM Data",
        template: "airtime",
        img: "",
        urlPath: "product",
        senderNumberRequired: true,
        isoSalesCurrency: "MWK",
        isoCurrency: "R",
        displaySalesCurrency: true
      },
      {
        isoCountry: 'mw',
        portiFolio: "airtelmalawi",
        icon: "",
        iconImg:"logo/airtel.png",
        text: "Airtel",
        template: "airtime",
        img: "",
        urlPath: "product",
        senderNumberRequired: true,
        isoSalesCurrency: "MWK",
        isoCurrency: "R",
        displaySalesCurrency: true
      }
    ]
  }